import(/* webpackMode: "eager" */ "/data/.cache/act/130c89cb4ceb89c3/hostexecutor/src/app/terms/page.jsx")